import React, {useEffect, useMemo, useReducer, useRef} from 'react';
import {connect} from "react-redux";
import {
  SIDEBAR_HIDDEN_BUTTONS,
  SIDEBAR_NAVIGATION_BUTTONS,
  SIDEBAR_SHAPE_BUTTONS,
  SIDEBAR_TYPE_AREA_NAVIGATION_BUTTONS, SQFT_FEATURES
} from "../../../../constants";
import {FormattedMessage, injectIntl} from "react-intl";
import $ from "jquery";
import {addChangeValuePopup, setSQFTActiveButton, setSQFTMenuOpened} from "../../../../../../actions/sqftMenuFunctions";
import EventManager from "../../../canvas/store/sqftEventManager";
import workspace from "../../../canvas/core/workspace";
import config from "../../../canvas/store/sqftConfig";
import FreeDraw from "../../../canvas/core/controls/freeDraw";
import {getIsSFTAreaGroup} from "../../../../helpers/sqftNavigationHelper";
import {getEdgeFeatureGroup, getEdgeFeatures} from "../../../../helpers/shapeHelper";
import AllFeaturesChecker from "../../../../../visComponents/allFeaturesChecker";
import WaterfallController from "../../../canvas/core/controls/WaterfallController";
import {handleFreeFormClick, handleMiteredClick, handleUnderlaymentClick} from "../../NavigationHelper";
import {getCommonVisualizerType} from "../../../../../../config";
import useFetchFeatures from "../../../../hocs/useFetchFeatures";
import LoadingSpinner from "../../../../../ui/loadingSpinner";
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import {hideSqftTooltip, showSqftTooltip} from "../../../../../../actions/sqftTooltipFunctions";

export const resetEvents = function () {
  EventManager.stealCursor(true);
  EventManager.resetCursor(self);
  workspace.setAllowEdges(false);
  workspace.setAllowBumpoutEdges(false);
};

const SqftToolMenuCountertop = (props) => {
  const {
    activeButton,
    menuOpened,
    setSQFTActiveButton,
    setSQFTMenuOpened,
    intl,
    showSqftTooltip,
    hideSqftTooltip
  } = props;

  const isSFTAreaGroup = getIsSFTAreaGroup();
  const edgeFeatureGroup = getEdgeFeatureGroup();

  let buttons = isSFTAreaGroup ? SIDEBAR_TYPE_AREA_NAVIGATION_BUTTONS : SIDEBAR_NAVIGATION_BUTTONS;

  const expanded = activeButton
    && menuOpened !== SIDEBAR_NAVIGATION_BUTTONS.bumpout
    && menuOpened !== SIDEBAR_HIDDEN_BUTTONS.toolWaterfall
    && menuOpened !== SIDEBAR_HIDDEN_BUTTONS.toolUnderlayment
    && menuOpened !== SIDEBAR_NAVIGATION_BUTTONS.mitered
    && (menuOpened === SIDEBAR_NAVIGATION_BUTTONS.move || Object.keys(buttons).some(buttonKey => menuOpened === buttonKey));

  const partIds = useMemo(() => expanded ? [SQFT_FEATURES.end_cap]: [], [expanded]);
  const { featuresData, isLoading } = useFetchFeatures(partIds);
  const edgeNavItems = getEdgeFeatures(edgeFeatureGroup);

  const shouldSkipEdgeButton = edgeNavItems.length === 0;

  // Object to store button states (enabled/disabled) and disable reason
  const buttonStates = {};
  const buttonDisableReasons = {};

  // Filter buttons and determine their states
  if (!isLoading && featuresData) {
    buttons = Object.keys(buttons).reduce((newButtons, buttonKey) => {
      let shouldRemove = false;
      let isDisabled = false;
      let disableReason = 'not_available'; // default reason

      // Check for edge button
      if (buttonKey === SIDEBAR_NAVIGATION_BUTTONS.edge) {
        if (shouldSkipEdgeButton) {
          shouldRemove = true;
        } else if (edgeNavItems.length === 0) {
          isDisabled = true;
          disableReason = 'not_available';
        }
      }

      // Check for toolWaterfall button in fireplace mode
      if (buttonKey === SIDEBAR_HIDDEN_BUTTONS.toolWaterfall && getCommonVisualizerType() === "fireplace") {
        shouldRemove = true;
      }

      // Check for end_cap button
      if (buttonKey === SIDEBAR_NAVIGATION_BUTTONS.end_cap) {
        const endCapData = featuresData.end_cap;
        if (!endCapData || !endCapData.allNavItems || endCapData.allNavItems.length === 0) {
          shouldRemove = true;
        } else if (endCapData.rows.length === 0) {
          isDisabled = true;
          disableReason = endCapData.wasFilteredByAR3D ? 'missing_3d_models' : 'not_available';
        }
      }

      if (shouldRemove) {
        return newButtons;
      }

      buttonStates[buttonKey] = isDisabled;
      buttonDisableReasons[buttonKey] = disableReason;
      newButtons[buttonKey] = buttons[buttonKey];
      return newButtons;
    }, {});
  } else if (shouldSkipEdgeButton) {
    buttons = Object.keys(buttons).reduce((newButtons, buttonKey) => {
      if (buttonKey !== SIDEBAR_NAVIGATION_BUTTONS.edge) {
        newButtons[buttonKey] = buttons[buttonKey];
      }
      return newButtons;
    }, {});
  }

  if (getCommonVisualizerType() === "fireplace") {
    buttons = Object.keys(buttons).reduce((newButtons, buttonKey) => {
      if (buttonKey !== SIDEBAR_HIDDEN_BUTTONS.toolWaterfall) {
        newButtons[buttonKey] = buttons[buttonKey];
      }
      return newButtons;
    }, {});
  }

  const [, forceUpdate] = useReducer(x => x + 1, 0);

  // Ref to track mount state
  const isMountedRef = useRef(true);

  useEffect(() => {
    // Cleanup on unmount
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const safeForceUpdate = () => {
    // Prevent state update on unmounted component
    if (!isMountedRef.current) return;
    forceUpdate();
  };

  const handleButtonClick = (buttonKey) => {
    // Prevent clicking on disabled buttons
    if (buttonStates[buttonKey]) {
      return;
    }

    setSQFTMenuOpened(buttonKey);
    setSQFTActiveButton(buttonKey);
    config.workspace.menuItemActive = buttonKey;
    resetEvents();
    switch (buttonKey) {
      case SIDEBAR_NAVIGATION_BUTTONS.move:
        setSQFTMenuOpened('');
        break;
      case SIDEBAR_SHAPE_BUTTONS.freeDraw:
      case SIDEBAR_TYPE_AREA_NAVIGATION_BUTTONS.freeDraw:
        FreeDraw.init();
        break;
      case SIDEBAR_SHAPE_BUTTONS.shapeFreeForm:
        handleFreeFormClick();
        break;
      case SIDEBAR_NAVIGATION_BUTTONS.resize:
        setSQFTMenuOpened('');
        setSQFTActiveButton(SIDEBAR_NAVIGATION_BUTTONS.resize);
        handleResizeClick();
        break;
      case SIDEBAR_NAVIGATION_BUTTONS.rotate:
        setSQFTMenuOpened('');
        setSQFTActiveButton(SIDEBAR_NAVIGATION_BUTTONS.rotate);
        handleRotateClick();
        break;
      case SIDEBAR_NAVIGATION_BUTTONS.angle:
        setSQFTMenuOpened('');
        handleAngleClick();
        break;
      case SIDEBAR_NAVIGATION_BUTTONS.text:
        setSQFTMenuOpened('');
        handleTextClick();
        break;
      case SIDEBAR_NAVIGATION_BUTTONS.label:
        setSQFTMenuOpened('');
        break;
      case SIDEBAR_NAVIGATION_BUTTONS.mitered:
        setSQFTMenuOpened(SIDEBAR_NAVIGATION_BUTTONS.mitered);
        handleMiteredClick();
        break;
      case SIDEBAR_NAVIGATION_BUTTONS.duplicate:
        setSQFTMenuOpened('');
        handleDuplicateClick();
        break;
      case SIDEBAR_NAVIGATION_BUTTONS.toolWaterfall:
        handleWaterfallClick();
        break;
      case SIDEBAR_HIDDEN_BUTTONS.toolUnderlayment:
        setSQFTMenuOpened(SIDEBAR_HIDDEN_BUTTONS.toolUnderlayment);
        handleUnderlaymentClick();
        break;
      case 'reset':
        handleResetClick();
        break;
    }

    $('.lightbox-option-selected').removeClass('lightbox-option-selected');
  };

  const handleMouseEnter = (event, buttonKey) => {
    if (buttonStates[buttonKey]) {
      const targetRect = event.currentTarget.getBoundingClientRect();
      const featureName = intl.formatMessage({ id: "sqft.navigation.submenu." + buttonKey });
      const disableReason = buttonDisableReasons[buttonKey];

      // Different messages based on disable reason
      let title, description;
      if (disableReason === 'missing_3d_models') {
        title = intl.formatMessage({ id: "sqft.navigation.missing_3d_models_title" });
        description = `${featureName} ${intl.formatMessage({ id: "sqft.navigation.missing_3d_models_description" })}`;
      } else {
        title = `${featureName} ${intl.formatMessage({ id: "sqft.navigation.not_available_title" })}`;
        description = `${featureName} ${intl.formatMessage({ id: "sqft.navigation.not_available_description" })}`;
      }

      showSqftTooltip({
        title,
        description,
        icon: <AutoFixHighIcon />,
        position: 'right',
        targetRect
      });
    }
  };

  const handleMouseLeave = () => {
    hideSqftTooltip();
  };

  const handleResizeClick = function () {
    EventManager.stealCursor(true);
    EventManager.resetCursor(self);
    workspace.setAllowEdges(true);
    workspace.setAllowLineHighlight(true);
    setTimeout(function () {
      workspace.setAllowLineHighlight(false);
    }, 1000);
  };

  const handleRotateClick = function () {
    EventManager.stealCursor(true);
    config.workspace.menuItemActive = "rotate-left";
  };

  const handleDuplicateClick = function () {
    EventManager.stealCursor(true);
    EventManager.setCursor("duplicate", this, true);
    config.workspace.menuItemActive = "duplicate";
  };

  const handleAngleClick = function () {
    EventManager.stealCursor(true);
    EventManager.resetCursor(self);
    config.highlight.rotateAngle = true;
    workspace.getShapes().forEach((shape) => {
      if (Array.isArray(shape.rotateAngleParts) && shape.rotateAngleParts.length) {
        // TODO: fix bumpout rotation and remove this
        if (shape.isWithBumpout()) return;
        shape.activateRotateAngle();
      }
    });
  };

  const handleTextClick = function () {
    // Empty function - placeholder for future implementation
  };

  const handleResetClick = function () {
    EventManager.stealCursor(true);
    EventManager.resetCursor(self);
  };

  const handleWaterfallClick = function () {
    workspace.setAllowBumpoutEdges(true);
    workspace.setAllowLineHighlight(true);
    WaterfallController.addWaterfall_onClick();
    setTimeout(function () {
      workspace.setAllowLineHighlight(false);
    }, 1000);
  };

  return (
    <nav className={"navigation side" + (expanded ? " expanded" : "")} data-side="navigation">
      <div className="navigation-list">
        {edgeFeatureGroup && edgeFeatureGroup.part && !edgeFeatureGroup.part.allFeaturesReceived
          ? <AllFeaturesChecker subPart={edgeFeatureGroup} callBack={safeForceUpdate} loaderOnly={true}/>
          : isLoading
            ? <LoadingSpinner />
            : !expanded ? null : Object.keys(buttons).map((buttonKey) => {
              const isDisabled = buttonStates[buttonKey];

              return (
                <button
                  key={buttonKey}
                  className={
                    "animated fadeInUp button button--" + buttonKey +
                    (isDisabled ? " button--disabled" : "")
                  }
                  onClick={() => handleButtonClick(buttonKey)}
                  onMouseEnter={(e) => handleMouseEnter(e, buttonKey)}
                  onMouseLeave={handleMouseLeave}
                >
                    <span className="button-text">
                      <FormattedMessage id={"sqft.navigation.submenu." + buttonKey}/>
                    </span>
                </button>
              );
            })}
      </div>
    </nav>
  );
};

const mapStateToProps = (store) => ({
  menuOpened: store.sqftMenuState.menuOpened,
  activeButton: store.sqftMenuState.activeButton
});

const mapDispatchToProps = {
  setSQFTMenuOpened,
  setSQFTActiveButton,
  addChangeValuePopup,
  showSqftTooltip,
  hideSqftTooltip,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SqftToolMenuCountertop)
);
